import React, { useContext, useMemo } from 'react';
import { useLoadScript } from '@react-google-maps/api';

import { Context } from '../../index';
import MapWrapper from './MapWrapper';

const libraries = ['geometry', 'drawing', 'places'];

const Location = () => {

  const { googleApiKey, siteKey, stepsRefs, translationsLocales } = useContext(Context);
  const mapLanguage = siteKey === 'global' ? 'en' : translationsLocales.filter(locale => locale.id === siteKey)[0].name;
  const region = siteKey === 'global' ? '' : siteKey.toUpperCase();


  const { isLoaded, loadError } =
    useLoadScript({
      googleMapsApiKey: googleApiKey,
      language: mapLanguage,
      libraries,
      region,
    });

  const MapContent = useMemo(
    () => isLoaded ? <MapWrapper ref={stepsRefs.location} /> : null,
    [isLoaded],
  );


  return (
    <div className="location">
      { MapContent }
    </div>
  );
};

export default Location;
